module.exports = __webpack_public_path__ + "static/favicon-31e0da547ef580f8016e1eb488d958a3.png";